<template>
  <div class="menus-modal-head">
    <span class="menus-modal-icon">
      <b-icon :icon="icon"></b-icon>
    </span>
    <div class="menus-modal-titles">
      <h5 class="menus-modal-title">{{ title }}</h5>
      <p v-if="subtitle" class="menus-modal-subtitle">{{ subtitle }}</p>
    </div>
    <button type="button" class="menus-modal-close" aria-label="بستن" @click="$emit('close')">
      <b-icon icon="x-lg"></b-icon>
    </button>
  </div>
</template>

<script>
import "./menus-ui.css";

export default {
  name: "MenuModalHeader",
  props: {
    icon: {
      type: String,
      default: 'list-nested'
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
}
</script>
